import getArtifactProductionStatus from "../utils/getArtifactProductionStatus";

import useArtifactProductionStatuses from "./useArtifactProductionStatuses";

export default function useArtifactProductionStatus({ artifact }) {
	const statuses = useArtifactProductionStatuses();

	const status = getArtifactProductionStatus({ artifact });

	return {
		status,
		...statuses[status],
	};
}
